// =====================================================
// Swiss Finance OS - Sign Up Page
// User registration entry point
// =====================================================

import { SignUpForm } from '@/components/auth/SignUpForm';

export default function SignUp() {
  return <SignUpForm />;
}